import React from "react";
import "../styles/confetti.css";

export const Confetti = () => {
  const pieces = Array.from({ length: 80 });

  return (
    <div className="confetti-container">
      {pieces.map((_, index) => (
        <span
          key={index}
          className="confetti-piece"
          style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 2}s`,
            animationDuration: `${3 + Math.random() * 2}s`,
          }}
        />
      ))}
    </div>
  );
};
